/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListAllWaitingJobApplicationsJobApplicationFromJSON, ListAllWaitingJobApplicationsJobApplicationToJSON, } from './ListAllWaitingJobApplicationsJobApplication.js';
/**
 * Check if a given object implements the ListAllWaitingJobApplicationsResult interface.
 */
export function instanceOfListAllWaitingJobApplicationsResult(value) {
    if (!('jobApplications' in value) || value['jobApplications'] === undefined)
        return false;
    return true;
}
export function ListAllWaitingJobApplicationsResultFromJSON(json) {
    return ListAllWaitingJobApplicationsResultFromJSONTyped(json, false);
}
export function ListAllWaitingJobApplicationsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobApplications': (json['jobApplications'].map(ListAllWaitingJobApplicationsJobApplicationFromJSON)),
    };
}
export function ListAllWaitingJobApplicationsResultToJSON(json) {
    return ListAllWaitingJobApplicationsResultToJSONTyped(json, false);
}
export function ListAllWaitingJobApplicationsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobApplications': (value['jobApplications'].map(ListAllWaitingJobApplicationsJobApplicationToJSON)),
    };
}
